export default {
  props: {
    plotId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      plotInfo: JSON.parse(localStorage.getItem('plotInfo'))
    };
  },
  methods: {
    initChart() {},
    // 获取数据
    getData() {}
  }
};